import { type Common } from './common.js';
import { type EhrInformation, type ImportRow } from './models/ehrInformation.js';
import { type ImportValidation } from './models/provider.js';

export class API {
  common: Common;
  baseEndpoint = '/ehr-information';

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(id: string): Promise<EhrInformation> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async equivalentById(
    id: string
  ): Promise<{ ehrInformation: EhrInformation; equivalent: EhrInformation[] }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/equivalent`);
    return await this.common.getJSON(url);
  }

  async import(args: { practiceId: string; importRows: ImportRow[] }): Promise<EhrInformation[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/import`);
    return await this.common.postJSON(url, args);
  }

  async importVerify(args: {
    practiceId: string;
    importRows: Record<string, string>[];
  }): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/import/verify`);
    return await this.common.postJSON(url, args);
  }

  async remove(id: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }
}
